export { default as PATHS } from './paths';
export { default as MENU } from './menu';
export { default as LOCALES } from './locales';
export { default as QUOTES } from './quotes';
export * from './urls';
export * from './campaign';
